/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPublicTabletBarbersQueryResponse, GetApiPublicTabletBarbersPathParams, GetApiPublicTabletBarbersQueryParams, GetApiPublicTabletBarbers400, GetApiPublicTabletBarbers403, GetApiPublicTabletBarbers404, GetApiPublicTabletBarbers500 } from "../entities/GetApiPublicTabletBarbers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiPublicTabletBarbers } from "../api/getApiPublicTabletBarbers";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiPublicTabletBarbersQueryKey = (branch_id: GetApiPublicTabletBarbersPathParams["branch_id"] | undefined, params: GetApiPublicTabletBarbersQueryParams) => [{ url: '/api/public/tablet/barbers' }, ...(params ? [params] : [])] as const

export type GetApiPublicTabletBarbersQueryKey = ReturnType<typeof getApiPublicTabletBarbersQueryKey>

export function getApiPublicTabletBarbersQueryOptions(branch_id: GetApiPublicTabletBarbersPathParams["branch_id"] | undefined, params: GetApiPublicTabletBarbersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiPublicTabletBarbersQueryKey(branch_id, params)
        return queryOptions<GetApiPublicTabletBarbersQueryResponse, ResponseErrorConfig<GetApiPublicTabletBarbers400 | GetApiPublicTabletBarbers403 | GetApiPublicTabletBarbers404 | GetApiPublicTabletBarbers500>, GetApiPublicTabletBarbersQueryResponse, typeof queryKey>({
         enabled: !!(branch_id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiPublicTabletBarbers(branch_id!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Мастера выбранного филиала с ближайшим временем записи по scoped runtime-плану. Endpoint работает только на текущий день
 * @summary Получить доступных мастеров (планшет)
 * {@link /api/public/tablet/barbers}
 */
export function useGetApiPublicTabletBarbers<TData = GetApiPublicTabletBarbersQueryResponse, TQueryData = GetApiPublicTabletBarbersQueryResponse, TQueryKey extends QueryKey = GetApiPublicTabletBarbersQueryKey>(branch_id: GetApiPublicTabletBarbersPathParams["branch_id"] | undefined, params: GetApiPublicTabletBarbersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiPublicTabletBarbersQueryResponse, ResponseErrorConfig<GetApiPublicTabletBarbers400 | GetApiPublicTabletBarbers403 | GetApiPublicTabletBarbers404 | GetApiPublicTabletBarbers500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiPublicTabletBarbersQueryKey(branch_id, params)
         

         const query = useQuery({
          ...getApiPublicTabletBarbersQueryOptions(branch_id, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetApiPublicTabletBarbers400 | GetApiPublicTabletBarbers403 | GetApiPublicTabletBarbers404 | GetApiPublicTabletBarbers500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}